import { render, staticRenderFns } from "./mrc_ess_staffListView.vue?vue&type=template&id=3b2d67f7&scoped=true&"
import script from "./mrc_ess_staffListView.vue?vue&type=script&lang=js&"
export * from "./mrc_ess_staffListView.vue?vue&type=script&lang=js&"
import style0 from "./mrc_ess_staffListView.vue?vue&type=style&index=0&id=3b2d67f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2d67f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
